import UnNotificationsQueue from './UnNotificationsQueue.vue';

export * from './module';
export * from './helpers';

export default UnNotificationsQueue;
